<template>
  <b-container fluid class="contents my-4 px-3">
    <div class="p-4">
      <b-row>
        <b-col md="12">
          <h3 class="fulfillment-form-header">
            Fees
            <i class="ic-tooltip" id="help-fees"></i>
            <b-popover target="help-fees"
              triggers="hover"
              content="Set applicable fees for our NEW Scan to Order features, delivery options, and more.">
            </b-popover>
          </h3>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="2" md="4">
          <b-form-group label="Deliver Now" label-class="fulfillment-form-label"></b-form-group>
        </b-col>
        <b-col lg="10" md="8">
          <div class="bg-white rounded p-4 form-container">
            <FulfillmentFeesForm
              origin="deliver_now"
              :key="`deliver_now-${feesFormKey}`"
              :selectedValue="form.deliver_now" />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col lg="2" md="4">
          <b-form-group label="Scheduled Delivery" label-class="fulfillment-form-label"></b-form-group>
        </b-col>
        <b-col lg="10" md="8">
          <div class="bg-white rounded p-4 form-container">
            <FulfillmentFeesForm
              origin="scheduled_delivery"
              :key="`scheduled_delivery-${feesFormKey}`"
              :selectedValue="form.scheduled_delivery"
              @getDeliverNowSettings="handleGetDeliverNowSettings" />
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-3" v-if="permission.hasAccess('store.table_ordering:topup-table_ordering')">
        <b-col lg="2" md="4">
          <b-form-group label-class="fulfillment-form-label">
            <template slot="label">
              Scan to Order Fee
              <i class="ic-tooltip" id="help-table-order-fees"></i>
              <b-popover target="help-table-order-fees"
                triggers="hover"
                content="Set your service fees for when we bill customers through our NEW Scan to Order feature">
              </b-popover>
            </template>
          </b-form-group>
        </b-col>
        <b-col lg="10" md="8">
          <div class="bg-white rounded p-4 form-container">
            <DineInFeeForm
              origin="table_ordering"
              :key="`table_ordering-${feesFormKey}`"
              :selectedValue="form.table_ordering" />
          </div>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';
import FulfillmentFeesForm from "@/components/fulfillment/FeesForm";
import DineInFeeForm from "@/components/fulfillment/DineInFeeForm";
import permission from "../../services/user.permission";
import notification from "@/services/notification";

function initForm() {
  return {
    level: 'merchant',
    deliver_now: {
      delivery_fee_type: null,
      base_fee_value: null,
      base_km_range: null,
      added_value_per_km: null,
      enable_minimum_spend: false,
      minimum_spend_amount: null,
      minimum_spend_currency: 'PHP'
    },
    scheduled_delivery: {
      same_deliver_now: false,
      delivery_fee_type: null,
      base_fee_value: null,
      base_km_range: null,
      added_value_per_km: null,
      enable_minimum_spend: false,
      minimum_spend_amount: null,
      minimum_spend_currency: 'PHP'
    },
    table_ordering: {
      dine_in_service_fee_unit: "",
      dine_in_service_fee_amount: 0,
      enable_dine_in_service_fee: false
    }
  }
}

export default {
  name: "FulfillmentFees",
  components: { FulfillmentFeesForm, DineInFeeForm },
  data() {
    return {
      form: initForm(),
      feesFormKey: 1,
      permission: permission
    }
  },
  computed: {
    ...mapGetters({
      errors: 'orderFulfillment/errors',
      user: 'auth/user',
      fulfillment_fees: 'orderFulfillment/fulfillment_fees',
      saveFulfillmentFeeMsg: 'orderFulfillment/saveFulfillmentFeesMsg'
    }),
    ...mapState("accountProfile", ["detail"]),
    ...mapState("branches", ["advanceSettings"]),
    merchant_uuid: {
      get() {
        return this.user.merchant_uuid;
      },
      set(merchant_uuid) {
        return merchant_uuid;
      }
    }
  },
  mounted() {
    // this.$root.$on('isTouchedValue', () => {
    //   ['deliver_now', 'scheduled_delivery'].map(keyObject => {
    //     Object.keys(this.form[keyObject]).map(key => {
    //       if (this.form[keyObject][key] !== this.fulfillment_fees[keyObject][key]) this.$root.$emit('changesDetected');
    //     });
    //   });
    // });
    this.$root.$on('updateSameDeliverNow', () => {
      if (this.form.scheduled_delivery.same_deliver_now) this.debouncedFormKeyUpdate();
    });
    this.$root.$on('saveFulfillmentChangesCancelled', (tab) => {
      if (tab === 'FulfillmentFees') this.setFeesSettings();
    });
    this.$root.$on('handleFulfillmentSave', (tab) => {
      if (tab === 'FulfillmentFees') this.handleSaveFeesSettings();
    });
  },
  beforeDestroy() {
    // this.$root.$off('isTouchedValue');
    this.$root.$off('updateSameDeliverNow');
    this.$root.$off('saveFulfillmentChangesCancelled');
    this.$root.$off('handleFulfillmentSave');
  },
  created() {
    this.handleGetFulfillmentFees();

    this.debouncedFormKeyUpdate = _.debounce(() => {
      this.feesFormKey = this.feesFormKey += 1;
    }, 400);
  },
  methods: {
    ...mapMutations({
      setErrors: "orderFulfillment/set_errors",
    }),
    ...mapActions({
      getFulfillmentFeesSettings: 'orderFulfillment/getFulfillmentFeesSettings',
      saveFulfillmentFeesSettings: 'orderFulfillment/saveFulfillmentFeesSettings',
      saveDineInFeeSettings: 'orderFulfillment/saveDineInFeeSettings',
      getDineInFeeSettings: 'branches/viewAdvanceSettings'
    }),
    async handleGetFulfillmentFees() {
      const param = {
        merchant_uuid: this.merchant_uuid,
        payload: {
          level: 'merchant'
        }
      };
      await this.getFulfillmentFeesSettings(param);
      this.setFeesSettings();
    },
    handleGetDeliverNowSettings() {
      this.form.scheduled_delivery = {
        same_deliver_now: this.form.scheduled_delivery.same_deliver_now,
        ...this.form.deliver_now
      };
      this.feesFormKey = this.feesFormKey += 1;
    },
    setFeesSettings() {
      this.setErrors(null);
      if(this.fulfillment_fees && this.fulfillment_fees.hasOwnProperty('table_ordering'))
        this.fulfillment_fees['table_ordering'].dine_in_service_fee_amount = 
          this.fulfillment_fees['table_ordering'].dine_in_service_fee_unit == 'PHP'
            && !this.fulfillment_fees['table_ordering'].dine_in_service_fee_amount
          ? '0.00' : this.fulfillment_fees['table_ordering'].dine_in_service_fee_amount;
      this.form = this.fulfillment_fees ? JSON.parse(JSON.stringify(this.fulfillment_fees)) : initForm();
      this.feesFormKey = this.feesFormKey += 1;
    },
    async handleSaveFeesSettings() {
      const form = this.form;
      const errors = {};

      ['deliver_now', 'scheduled_delivery', 'table_ordering'].forEach(keyObject => {
        if(keyObject == 'table_ordering' && form[keyObject].enable_dine_in_service_fee && permission.hasAccess('store.table_ordering:topup-table_ordering')) {
            if(!form[keyObject].dine_in_service_fee_unit) errors[`${keyObject}.dine_in_service_fee_unit`] = 'Dine-in service fee type is required.';
            if(!form[keyObject].dine_in_service_fee_amount || form[keyObject].dine_in_service_fee_amount <= 0) errors[`${keyObject}.dine_in_service_fee_amount`] = 'Dine-in service fee amount is required and must be greater than 0.';
            if(form[keyObject].dine_in_service_fee_unit == '%' && form[keyObject].dine_in_service_fee_amount > 100) errors[`${keyObject}.fee`] = 'Dine-in service fee percentaage must not be greater than 100%';
        } else if(keyObject != 'table_ordering') {
          if (!form[keyObject].delivery_fee_type) errors[`${keyObject}.delivery_fee_type`] = 'Delivery fee is required.';

          if (!form[keyObject].base_fee_value || !parseFloat(form[keyObject].base_fee_value)) 
            errors[`${keyObject}.base_fee_value`] = 'Delivery base fee value is required.';

          if (form[keyObject].delivery_fee_type === 'dynamic' && !form[keyObject].base_km_range) errors[`${keyObject}.base_km_range`] = 'Delivery base kilometer range is required.';

          if (form[keyObject].delivery_fee_type === 'dynamic' && !form[keyObject].added_value_per_km) errors[`${keyObject}.added_value_per_km`] = 'Added value per kilometer is required.';

          if (form[keyObject].enable_minimum_spend && !form[keyObject].minimum_spend_amount) errors[`${keyObject}.minimum_spend_amount`] = 'Minimum spend amount is required.';

        }
      });

      this.setErrors(errors);

      const formatNumbers = (value) => {
        return value && Number((value).toString().replace(/,/g, ""));
      };

      if (!this.errors || Object.keys(this.errors).length === 0) {
        const form = this.form;
        const payload = {
          level: form.level,
          deliver_now: {
            delivery_fee_type: form.deliver_now.delivery_fee_type,
            delivery_base_value: formatNumbers(form.deliver_now.base_fee_value),
            delivery_base_km_range: formatNumbers(form.deliver_now.base_km_range),
            delivery_base_km: formatNumbers(form.deliver_now.added_value_per_km),
            enable_minimum_spend: form.deliver_now.enable_minimum_spend,
            minimum_spend_amount: formatNumbers(form.deliver_now.minimum_spend_amount),
            minimum_spend_currency: form.deliver_now.minimum_spend_currency,
          },
          scheduled_delivery: {
            same_deliver_now: form.scheduled_delivery.same_deliver_now,
            delivery_fee_type: form.scheduled_delivery.delivery_fee_type,
            delivery_base_value: formatNumbers(form.scheduled_delivery.base_fee_value),
            delivery_base_km_range: formatNumbers(form.scheduled_delivery.base_km_range),
            delivery_base_km: formatNumbers(form.scheduled_delivery.added_value_per_km),
            enable_minimum_spend: form.scheduled_delivery.enable_minimum_spend,
            minimum_spend_amount: formatNumbers(form.scheduled_delivery.minimum_spend_amount),
            minimum_spend_currency: form.scheduled_delivery.minimum_spend_currency,
          }
        };

        await this.saveFulfillmentFeesSettings(payload);
        if(permission.hasAccess('store.table_ordering:topup-table_ordering')) {
          await this.saveDineInFeeSettings(form.table_ordering);
        }
        if (!this.errors || Object.keys(this.errors).length === 0) {
          notification.success(this.saveFulfillmentFeeMsg);
          this.handleGetFulfillmentFees();
          this.$root.$emit('fulfillmentSavedSuccessful');
        }
      }
    }
  },
  watch: {
    'form.deliver_now': {
      deep: true,
      handler() {
        if (this.form.scheduled_delivery.same_deliver_now) {
          this.form.scheduled_delivery = {
            same_deliver_now: this.form.scheduled_delivery.same_deliver_now,
            ...this.form.deliver_now
          };
        }
      }
    },
    'form.scheduled_delivery': {
      deep: true,
      handler(scheduledDelivery) {
        const { same_deliver_now, ...scheduled_delivery } = scheduledDelivery;
        Object.keys(scheduled_delivery).forEach(key => {
          if (scheduled_delivery[key] !== this.form.deliver_now[key]) this.form.scheduled_delivery.same_deliver_now = false;
        });
      }
    }
  }
}
</script>
